import { Input } from './';

import React, { Component } from 'react';
import { get, invoke, isNil } from 'lodash';

// TODO Locale support for ./, if precision!
class NumberInput extends Component {
  constructor(props) {
    super(props);
    this.precision = get(props, 'precision', 2);
    this.state = {
      value: this.format(props.value, this.precision),
      error: false,
    };
  }

  format = value => value && Number.parseFloat(value).toFixed(this.precision);

  parse = value => {
    if (value === undefined) return;
    if (typeof value === 'string' && !value.length) return;

    value = value.replace(',', '.');

    const parsedValue = Number.parseFloat(value);
    if (isNaN(parsedValue)) return NaN;

    const formattedValue = String(this.format(parsedValue));
    return formattedValue.startsWith(value) ? parsedValue : NaN;
  };

  onChange = (event, { value, ...rest }) => {
    const parsedValue = this.parse(value);
    if (isNil(parsedValue) || !isNaN(parsedValue)) {
      invoke(this.props, 'onChange', event, { value: parsedValue, ...rest });
      this.setState({ error: false });
    }
    this.setState({ value });
  };

  onBlur = () => {
    const { value } = this.state;
    const parsedValue = this.parse(value);
    this.setState({ error: value.length > 0 && isNaN(parsedValue) });
  };

  render() {
    const { precision, ...props } = this.props;
    const { value, error } = this.state;

    return (
      <Input
        {...props}
        value={value || ''}
        error={error}
        pattern={precision ? '[1-9]([.,0-9]+)?' : '[1-9]([0-9]+)?'}
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    );
  }
}

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/NumberInput.js